/* eslint-disable no-alert */
import { API_URL } from "@daytrip/legacy-config";

const FRESH_MIGRATION_BASE_URL = `${API_URL}`;

const fetchWithAlert = async (url: string) => {
    const response = await fetch(url);
    alert(`Done: ${JSON.stringify({ status: response.status, ok: response.ok })}`);
};

export const migrateDrivers = async () => {
    await fetchWithAlert(`${FRESH_MIGRATION_BASE_URL}/migrate-drivers`);
};

export const migrateCompanies = async () => {
    await fetchWithAlert(`${FRESH_MIGRATION_BASE_URL}/migrate-companies`);
};

export const migrateCompanyDrivers = async () => {
    await fetchWithAlert(`${FRESH_MIGRATION_BASE_URL}/migrate-company-drivers`);
};

export const migrateVehicleMakes = async () => {
    await fetchWithAlert(`${FRESH_MIGRATION_BASE_URL}/migrate-vehicle-makes`);
};

export const migrateVehicleModels = async () => {
    await fetchWithAlert(`${FRESH_MIGRATION_BASE_URL}/migrate-vehicle-models`);
};

export const migrateVehicles = async () => {
    await fetchWithAlert(`${FRESH_MIGRATION_BASE_URL}/migrate-vehicles`);
};

export const syncConfirmedOrder = async (legacyOrderId: string) => {
    await fetchWithAlert(`${FRESH_MIGRATION_BASE_URL}/sync-confirmed-order?id=${legacyOrderId}`);
};
